import React from "react";

import PageNavbar from "@insightfulscience/atomic-react/PageNavbar";
import PageNavbarItem from "@insightfulscience/atomic-react/PageNavbar/Item";
import PageNavbarLink from "@insightfulscience/atomic-react/PageNavbar/Link";

const HeroIconSectionLabarchives = () => {
	return (
		<PageNavbar alignHorizontal="around" bgColor="" fullWidthBorder>
			<PageNavbarItem>
				<PageNavbarLink href="#eln">ELN</PageNavbarLink>
			</PageNavbarItem>
			<PageNavbarItem>
				<PageNavbarLink href="#inventory">Inventory</PageNavbarLink>
			</PageNavbarItem>
			<PageNavbarItem>
				<PageNavbarLink href="#scheduler">Scheduler</PageNavbarLink>
			</PageNavbarItem>
			<PageNavbarItem>
				<PageNavbarLink href="#eln-for-education">ELN for Education</PageNavbarLink>
			</PageNavbarItem>
		</PageNavbar>
	);
};

export default HeroIconSectionLabarchives;
